export default __webpack_public_path__ + "static/media/ARTIST-11 (2-3).1662c91e.jpg";